import React, { useEffect, useState } from 'react'
import FullSpectrum from '../../components/full-spectrum/Full_spectrum'
import HeroSection from '../../components/hero-section/HeroSection'
import UnifiedTeam from '../../components/unified-team/UnifiedTeam'
import FullTech from '../../components/full-tech/full-tech'
import Footer from '../../components/footer/Footer'
import Navigation  from '../../components/navigation/Navigation'
import Products from '../../components/products/products'

import CardStyle1 from '../../components/card-style-1/card-style-1'

import { Col, Container, Row } from 'react-bootstrap'
import AnnouncementBar from '../../components/announcement/AnnouncementBar'
import Ai_Readiness from '../../components/ai_readiness/Ai_Readiness'
import "../../index.css"

const Home = () => {
  useEffect(() => {
    // window.scrollTo(0, 0)
  }, [])

  return (
    <div>

      <Navigation />

      <div className="demo">
      <HeroSection   />
      <Ai_Readiness/></div>

      <UnifiedTeam />
      <FullSpectrum  />
      <FullTech />

      <div className='container text-center'>
        <div className='digital_section_title_subsections'>
          <h2 className='common-title mb-20'>Why Agentic AI?</h2>
              <p className='mb-20'>
                Why businesses choose Agentic AI? Agentic AI goes beyond rule-based automation. <br></br>It enables systems that reason, act, and evolve,
                accelerating outcomes with measurable impact.
              </p>
              <div className='digital_cards_section  mb-20'>
                  <Row className='mt-2'>
                        <Col  key={1} lg='3'>
                        <CardStyle1 title='Context-aware decisioning and actions' />
                        </Col>
                        <Col  key={2} lg='3'>
                        <CardStyle1 title='Continuous learning from feedback and outcomes' />
                        </Col>
                        <Col  key={3} lg='3'>
                        <CardStyle1 title='Ethical by design with transparent controls' />
                        </Col>
                        <Col  key={4} lg='3'>
                        <CardStyle1 title='Built for scale across teams and platforms' />
                        </Col>
                  </Row>
              </div>
        </div>
      </div>
      <Products />
      <Footer />


      </div>

  )
}

export default Home
